export default __webpack_public_path__ + "static/media/Sandro@2x.6f96ede5.jpg";